import script from "./ErrorIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__